module.exports = __webpack_public_path__ + "img/28_75.168cb5e6.png";